<template>
  <v-dialog v-model="show" @click:outside="close" width="775px">
    <!-- <template v-slot:activator="{ on }"> </template> -->
    <div class="modal" style="height: 424px">
      <v-row>
        <div class="icon-modal table-cell" style="height: 424px">
          <v-layout class="align-center">
            <v-flex>
              <img class="custom-cancel" style="top:-110px" :src="require('@/assets/dele.png')" alt=""/>
            </v-flex>
          </v-layout>
        </div>
        <v-col class="table-cell modal-content">
          <div class="d-flex justify-space-between">
            <h6 class="modal-title mb-5">Cancel Account</h6>
          </div>
          <div class="content_cont_modal">
            <p class="custom-cancel owner" style="font-family: Roboto !important; font-weight: 400 !important;">
              Cancelling your account will disable access to the application for all of your users.</p>
            <p class="custom-cancel owner" style="font-family: Roboto !important; font-weight: 400 !important;">Your
              agent and homeowner will be notified that you have removed yourself and your users.</p>
            <p class="custom-cancel owner" style="font-family: Roboto !important; font-weight: 400 !important;">Your
              access will remain active until the end of your billing cycle.</p>
            <p class="custom-cancel owner" style="font-family: Roboto !important; font-weight: 400 !important;">Would
              you like to proceed with the cancellation of your account?</p>
            <div class="cancel-privacy-row">
              <span class="cancel-privacy-text">Want a copy of your data first?</span>
              <button
                  v-if="!exportRequested"
                  type="button"
                  class="cancel-privacy-link"
                  :disabled="exporting"
                  @click="onRequestExport"
              >{{ exporting ? 'Requesting…' : 'Export my data' }}</button>
              <span v-else class="cancel-privacy-success">Export requested — we'll email it.</span>
            </div>
            <p v-if="exportError" class="cancel-privacy-error">{{ exportError }}</p>
          </div>
          <div class="d-flex" style="position: relative;left: 3px;top: 13px;">
            <v-btn
                class="btn-blanco mr-6 custom-cancel"
                rounded
                depressed
                style=""
                @click="delete_account"
            >yes
            </v-btn>
            <v-btn
                class="btn-azul custom-cancel owner"
                rounded
                depressed
                style=""
                @click="close"
            >no
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<style scoped>
.cancel-privacy-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 14px;
  font-family: Roboto, Arial, sans-serif;
  font-size: 13px;
}
.cancel-privacy-text { color: #5e6b85; }
.cancel-privacy-link {
  background: none;
  border: none;
  color: #2bace2;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}
.cancel-privacy-link:disabled { opacity: 0.5; cursor: not-allowed; text-decoration: none; }
.cancel-privacy-success { color: #2e7d32; font-weight: 500; }
.cancel-privacy-error { color: #c0392b; font-size: 12px; margin: 6px 0 0; }
</style>
<script>
import { requestDataExport } from "@/util/data_export";

export default {
  props: ['show', 'hide'],
  data: () => ({
    image: require("@/assets/logo.svg"),
    exporting: false,
    exportRequested: false,
    exportError: '',
  }),
  watch: {
    show(val) {
      if (val) {
        this.exporting = false;
        this.exportRequested = false;
        this.exportError = '';
      }
    },
  },
  components: {},
  methods: {
    async delete_account() {
      await this.$store.dispatch("Billing/delete_account");
      this.hide();
      await this.$store.dispatch("Authenticate/logout");
    },
    close: function () {
      this.hide();
    },
    async onRequestExport() {
      if (this.exporting || this.exportRequested) return;
      this.exporting = true;
      this.exportError = '';
      try {
        await requestDataExport();
        this.exportRequested = true;
      } catch (err) {
        console.error('Data export request failed:', err);
        this.exportError = "We couldn't start your export. Please try again or contact support@kiey.com.";
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>
